import { fetchJSONUnsafe } from '../../utils/fetchJSON.js';
import { unique } from '../../utils/unique.js';
const refsCache = {};
const EXCLUSIONS = ['/portal-resources']; // portal-resources are handled only at compile-time
export const fetchRefs = async (refs) => Object.fromEntries((await Promise.allSettled(unique(refs)
    .filter(($ref) => !EXCLUSIONS.some((_) => $ref.startsWith(_)))
    .map(async ($ref) => [
    $ref,
    (refsCache[$ref] ||= await fetchJSONUnsafe($ref)),
])))
    .filter((res) => res.status === 'fulfilled')
    .map(({ value }) => value));
//# sourceMappingURL=fetchRefs.js.map